import { __extends } from "tslib";
import { deserializeAws_restJson1_1GetEmailChannelCommand, serializeAws_restJson1_1GetEmailChannelCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetEmailChannelCommand = /** @class */ (function (_super) {
    __extends(GetEmailChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetEmailChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetEmailChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetEmailChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1GetEmailChannelCommand(input, context);
    };
    GetEmailChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1GetEmailChannelCommand(output, context);
    };
    return GetEmailChannelCommand;
}($Command));
export { GetEmailChannelCommand };
//# sourceMappingURL=GetEmailChannelCommand.js.map